import React from 'react';
import styles from '../app/App.scss';
import { t } from '../../services/i18nService';
import a11yIcewormService from '../../services/a11yIcewormService';
import a11yIIBScreenReaderService, { A11yForIIBScreenReaderIteration } from '../../services/a11yIIBScreenReaderService';

const SkipLink = () => {
    const skipLinkClickHandler = (evt) => {
        document.getElementById('footer-nav-wrapper').focus();
        evt.preventDefault();
        return false;
    };

    const isIcewormFeatureEnabled = a11yIcewormService.isIcewormHandoffEnabled();
    const isA11yV7 = a11yIIBScreenReaderService.isA11yIterationForIIBScreenReaderSupported(A11yForIIBScreenReaderIteration.v7);
    const ariaLabelValue = isA11yV7 ? undefined : t('main.skipLinkAriaLabelText');

    return (
        <button
            {...(isIcewormFeatureEnabled && { id: 'skip-to-nav-link' })}
            className={styles.skipToNavigationLink}
            onClick={skipLinkClickHandler}
            aria-label={ariaLabelValue}
        >
            {t('main.skipLink')}
        </button>
    );
};

export default SkipLink;
